export interface HtmlPageResult {
  totalPages: number
  totalItems: number
  htmlContent: string
}

export async function fetchHtmlPage(endpoint: string, query: URLSearchParams): Promise<HtmlPageResult> {
  const response = await fetch(`${endpoint}?${query}`, {method: 'GET'})
  if (!response.ok) {
    const message = await response.text()
    throw new Error(message)
  }

  const totalPages = parseIntHeader("X-TotalPages", response)
  const totalItems = parseIntHeader("X-TotalItems", response)
  const htmlContent = await response.text()
  return {totalPages, totalItems, htmlContent}
}

function parseIntHeader(name: string, response: Response): number {
  const headerValue = response.headers.get(name) || "0"
  return parseInt(headerValue, 10) || 0
}
